import { render, staticRenderFns } from "./WomanCU.vue?vue&type=template&id=585c0e96&scoped=true"
import script from "./WomanCU.vue?vue&type=script&lang=js"
export * from "./WomanCU.vue?vue&type=script&lang=js"
import style0 from "./WomanCU.vue?vue&type=style&index=0&id=585c0e96&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585c0e96",
  null
  
)

export default component.exports